// removed by extract-text-webpack-plugin
module.exports = {"root":"MiniStoryCard__root--1S8As","headline":"MiniStoryCard__headline--3wPnn","subtext":"MiniStoryCard__subtext--3lzhn","featured":"MiniStoryCard__featured--1hk0W","bounce":"MiniStoryCard__bounce--1aQpx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/MiniStoryCard/MiniStoryCard.css
// module id = ./src/components/Library/MiniStoryCard/MiniStoryCard.css
// module chunks = 2